<template>
  <v-dialog width="500px" v-model="viewMenu">
    <v-card class="pa-7">
        <v-card-title class="mx-n7 mt-n7 popup-header" primary-title>{{title}}</v-card-title>
        <v-layout row wrap>
          <v-flex xs12>
            <v-card-text v-if="stab">
              <v-layout row wrap>
                <v-flex xs3>
                  <v-subheader v-text="'Startknoten:'"></v-subheader>
                </v-flex>
                <v-flex xs6>
                  <v-select dense :items="knoten" ref="Select1" v-model="stab.StartKnoten" @change="checkKnotenChange(0)" item-text="info" :menu-props="{ offsetY: true }" return-object hide-details label="Knoten 1" single-line required></v-select>
                </v-flex>
                <v-flex xs2 class="text-xs-left">
                    <v-btn-toggle>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                        <v-icon v-on="on" class="pt-3 px-1" flat @click="pickKnoten('StartKnoten')" style="transform: scaleX(-1)">near_me</v-icon>
                        </template>
                        <span>Auswahl mit Maus</span>
                    </v-tooltip>
                    <v-icon class="pt-3 px-1" flat color="green" @click="$store.commit('newKnoten')">add</v-icon>
                    <v-icon class="pt-3 px-1" flat color="orange" v-if="stab.StartKnoten" @click="$store.commit('editKnoten',stab.StartKnoten)">edit</v-icon>
                    </v-btn-toggle>
                </v-flex>
                <v-flex xs3>
                  <v-subheader v-text="'Endknoten:'"></v-subheader>                  
                </v-flex>
                <v-flex xs6>
                  <v-select dense :items="knoten" ref="Select2" v-model="stab.EndKnoten" @change="checkKnotenChange(1)"  item-text="info" :menu-props="{ offsetY: true }" return-object hide-details label="Knoten 2" single-line required></v-select>
                </v-flex>
                <v-flex xs2 class="text-xs-left">
                    <v-btn-toggle>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                        <v-icon v-on="on" class="pt-3 px-1" flat @click="pickKnoten('EndKnoten')" style="transform: scaleX(-1)">near_me</v-icon>
                        </template>
                        <span>Auswahl mit Maus</span>
                    </v-tooltip>
                    <v-icon class="pt-3 px-1" flat color="green" @click="$store.commit('newKnoten')">add</v-icon>
                    <v-icon class="pt-3 px-1" flat color="orange" v-if="stab.EndKnoten" @click="$store.commit('editKnoten',stab.EndKnoten)">edit</v-icon>
                    </v-btn-toggle>
                </v-flex>     
                <v-flex xs3>
                  <v-subheader v-text="'Querschnitt:'"></v-subheader>                  
                </v-flex>
                <v-flex xs6>
                  <v-select dense :items="querschnitte" v-model="stab.Querschnitt" item-text="name" @click:append-outer="$store.commit('editQuerschnitt',stab.Querschnitt)" :menu-props="{ offsetY: true }" return-object hide-details label="Querschnitt" single-line required></v-select>
                </v-flex>
                <v-flex xs2 class="text-xs-left">
                    <v-btn-toggle>
                    <v-icon class="pt-3 px-1" flat color="green" @click="$store.commit('newQuerschnitt')">add</v-icon>
                    <v-icon class="pt-3 px-1" flat color="orange" v-if="stab.Querschnitt" @click="$store.commit('editQuerschnitt',stab.Querschnitt)">edit</v-icon>
                    </v-btn-toggle>
                </v-flex> 
                <v-flex xs6>
                  <v-checkbox class="pl-3" label="Fachwerkstab" v-model="stab.isFachwerkstab"></v-checkbox>
                </v-flex>
                <v-flex xs3>
                  <v-subheader v-text="'Stabteilungen:'" class="pt-4"></v-subheader>  
                </v-flex>
                <v-flex xs1>
                    <v-text-field type="number" step="1" min="2" max="30" v-model.number="stab.Stabteilungen"></v-text-field>
                </v-flex>

                <v-flex xs3>
                  <v-subheader v-text="'Startgelenk:'"></v-subheader>                  
                </v-flex>
                <v-flex xs6>
                  <v-select dense :items="gelenke" ref="selectStartGelenk" clearable v-model="stab.Gelenke[0]" item-text="info" :menu-props="{ offsetY: true }" return-object hide-details label="Startgelenk" single-line></v-select>
                </v-flex>
                <v-flex xs2 class="text-xs-left">
                    <v-btn-toggle>
                    <v-icon class="pt-3 px-1" flat color="green" @click="$store.commit('newGelenk')">add</v-icon>
                    <v-icon class="pt-3 px-1" flat color="orange" v-if="stab.Gelenke[0]"  @click="$store.commit('editGelenk',stab.Gelenke[0])">edit</v-icon>
                    </v-btn-toggle>
                </v-flex> 
                <v-flex xs3>
                  <v-subheader v-text="'Endgelenk:'"></v-subheader>                  
                </v-flex>
                <v-flex xs6>
                  <v-select dense :items="gelenke" ref="selectEndGelenk" clearable v-model="stab.Gelenke[1]" item-text="info" :menu-props="{ offsetY: true }" return-object hide-details label="Endgelenk" single-line></v-select>
                </v-flex>
                <v-flex xs2 class="text-xs-left">
                    <v-btn-toggle>
                    <v-icon class="pt-3 px-1" flat color="green" @click="$store.commit('newGelenk')">add</v-icon>
                    <v-icon class="pt-3 px-1" flat color="orange" v-if="stab.Gelenke[1]" @click="$store.commit('editGelenk',stab.Gelenke[1])">edit</v-icon>
                    </v-btn-toggle>
                </v-flex>                                           
              </v-layout>
            </v-card-text>
          </v-flex>
        </v-layout>
        <v-divider></v-divider>
        <v-layout row wrap>
          <v-flex xs12>
            <v-card-actions>
                <v-btn small @click="apply()" color="grey lighten-2" >Übernehmen</v-btn>
                <v-btn small @click="cancel()" color="grey lighten-2" >Abbrechen</v-btn>
              <v-btn small v-if="!$store.getters.newStab" @click="deleteStab()" color="grey lighten-2"><v-icon dark color="red">delete_forever</v-icon>Löschen</v-btn>
            </v-card-actions>
          </v-flex>
        </v-layout>
      <!-- </v-container> -->
    </v-card>
  </v-dialog>
</template>

<script>
import Stab from '../../js/Stab.js'










// this is an async timeout util (very useful indeed)
const timeout = async ms => new Promise(res => setTimeout(res, ms));

async function waitUserInput(watcher) {
    while (watcher[0] === false || watcher[0] === undefined) {
        await timeout(50); // pause script but avoid browser to freeze ;)
        //console.log('...', watcher)
        } 
}

export default {
    data(){
        return{
            hideOverlay: false,
            stab: undefined,
            BoolStartGelenk: false,
            BoolEndGelenk: false
        }
    },
    computed: {
        knoten() { return this.$store.state.StatikSystem.Knotenliste },
        gelenke() { return this.$store.state.StatikSystem.Gelenkliste },
        querschnitte() { return this.$store.state.StatikSystem.Querschnittliste },
        title() { return this.$store.getters.newStab || !this.cStab ? 'Neuer Stab' : this.cStab.name +' bearbeiten'},
        viewMenu: {
            get() { return this.$store.getters.vStabMenu },   
            set(value) { this.$store.commit('setvStabMenu', value)} 
        },
        cStab: {
            get() { return this.$store.getters.cStab },
            }
        },
        
    methods: {
        checkKnotenChange(position){
            if(this.stab.StartKnoten == this.stab.EndKnoten){
                if(position == 0) {
                    this.stab.EndKnoten = undefined
                    this.$refs.Select2.selectedItems = []
                } else {
                    this.stab.StartKnoten = undefined
                    this.$refs.Select1.selectedItems = []
                } 
            }
        },

        async pickKnoten(KnotenPos){
            if(KnotenPos){
            // this.hideOverlay=true
            this.viewMenu = false
            this.$store.state.Selection.Knoten = []
            this.$store.commit('drawKnotenSelection')
            await waitUserInput(this.$store.state.Selection.Knoten)
            this.$forceUpdate()
            this.stab[KnotenPos] = this.$store.state.Selection.Knoten[0]
            console.log('Knoten wurde gewählt', this.$store.state.Selection.Knoten[0])
            this.viewMenu = true
            // this.hideOverlay=false
            }
        },

        async apply(){
          if (this.stab.Querschnitt && this.stab.StartKnoten && this.stab.EndKnoten){
            await this.$store.dispatch('StabDialogApply', this.stab)
            // Falls weitere Stäbe eingegeben werden können wird hier der Endknoten als Startknoten für den nächsten Stab gesetzt und man muss nur noch den Knoten2 wählen.
            if (this.$store.getters.newStab){
                this.stab = new Stab(null,this.stab.EndKnoten, undefined, this.stab.Querschnitt, this.stab.StartGelenk, this.stab.EndGelenk, this.stab.isFachwerkstab, this.stab.Stabteilungen)
            } 
            // Falls nur ein Stab geändert wird wird der Dialog zurück gesetzt.
            else {
                this.stab = undefined
            }
            this.$forceUpdate()
          }
        },
        cancel(){
            this.viewMenu = false
            // this.cStab = undefined
            this.stab = undefined
        },
        deleteStab(){
            this.$store.commit('StabDialogDelete')
            this.stab = undefined
        },
        
    },
    beforeUpdate(){
        if (!this.stab && this.viewMenu) {
            this.stab = new Stab(null,this.cStab.StartKnoten, this.cStab.EndKnoten, this.cStab.Querschnitt, this.cStab.StartGelenk, this.cStab.EndGelenk, this.cStab.isFachwerkstab, this.cStab.Stabteilungen)
        } 
    },
}
</script>

<style>
  .v-select__selections {
    font-size: 0.8em;
  }
  /* .v-list-item__content {
    font-size: 0.3em;
  } */
</style>